import { formatCurrency } from "../helper/helper";

const WalletTab = ({ wallet, loading }) => {
  if (loading)
    return (
      <div className="cpv__tab-empty">
        <div className="cpv__spinner" />
      </div>
    );

  const balance = wallet?.defaultAmount ?? wallet?.balance ?? null;
  const updatedAt = wallet?.updatedAt ?? null;
  const transactions = wallet?.transactions ?? [];

  return (
    <div className="cpv__wallet-wrap">
      <div className="cpv__wallet-balance-card">
        <span className="cpv__wallet-bal-label">WALLET BALANCE</span>
        <span className="cpv__wallet-bal-value">{formatCurrency(balance)}</span>
        {updatedAt && <span className="cpv__wallet-bal-sub">Updated {updatedAt}</span>}
      </div>

      <div className="cpv__wallet-txn-list">
        {transactions?.length === 0 ? (
          <div className="cpv__tab-empty">No transactions found.</div>
        ) : (
          transactions?.map((t, i) => (
            <div key={i} className="cpv__wallet-txn-row">
              <div>
                <div className="cpv__wallet-txn-title">
                  {t?.description || t?.type || "Transaction"}
                </div>
                <div className="cpv__wallet-txn-date">{formatDate(t?.date || t?.createdAt)}</div>
              </div>
              <span className={`cpv__wallet-txn-amt ${t?.amount > 0 ? "positive" : "negative"}`}>
                {t?.amount > 0 ? "+" : ""}
                {formatCurrency(t?.amount)}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
export default WalletTab;
